const footerContent = {
  Headings: [
    {
      text: "Discover Bitsclan",
    },
    {
      text: "Resources",
    },
    {
      text: "Career",
    },
    {
      text: "Get in Touch",
    },
    {
      text: "Trusted By",
    },
    {
      text: "Follow Us On",
    },
    {
      text: "Schedule a Call",
    },
  ],
  services: [
    {
      label: "AI ML Services",
      path: "/ai-ml-development-services",
    },
    {
      label: "AI Chatbot Development",
      path: "/ai-chatbot-development-services",
    },
    {
      label: "AI Automation Services",
      path: "/ai-automation-agency",
    },
    {
      label: "AI Agent Development",
      path: "/ai-agent-development-services",
    },
    {
      label: "Generative AI Development",
      path: "/generative-ai-development-services",
    },
    {
      label: "BlockChain Development",
      path: "/blockchain-development-services",
    },
    {
      label: "Custom Software Development",
      path: "/custom-software-development-services",
    },
    {
      label: "Web Application Development",
      path: "/web-app-development-services",
    },
    {
      label: "Mobile App Development",
      path: "/mobile-app-development-services",
    },
    // {
    //   label: "Quality Assurance Services",
    //   path: "/quality-assurance-services",
    // },
  ],
  company: [
    { label: "About Us", path: "/about-us" },
    { label: "Engagement Models", path: "/engagment-model" },
    // { label: "Portfolio", path: "/portfolio" },
    { label: "Blogs", path: "/blogs" },
    // { label: "Contact Us", path: "/contact-us", highlight: true },
  ],
  career: [{ label: "Join a Team", path: "https://www.theremotepad.com/join-a-team" }],
  trustedBy: [
    {
      name: "Clutch",
      img: "/images/clutch-footer.svg",
      link: "https://clutch.co/profile/bitsclan-it-solutions?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=logo&utm_term=bitsclan.com#highlights",
    },
    {
      name: "Payoneer",
      img: "/images/clutch-icons/payoneer-white.png",
      link: "https://www.youtube.com/watch?v=LDmv2CrkM1c&ab_channel=BitsclanITSolutions",
    },
  ],
  socialLinks: [
    {
      platform: "Facebook",
      icon: "fa-brands fa-square-facebook",
      link: "https://www.facebook.com/bitsclan",
    },
    {
      platform: "LinkedIn",
      icon: "fa-brands fa-linkedin",
      link: "https://www.linkedin.com/company/bitsclanitsolutions",
    },
    // {
    //   platform: "Instagram",
    //   icon: "fa-brands fa-square-instagram",
    //   link: "https://www.instagram.com/bitsclansolutions/",
    // },
  ],
  copyright: "© 2025 All Rights Reserved.",
  copyrightLinks: [
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Terms & conditions", path: "/terms-and-conditions" },
  ],
  modal: {
    id: "comingsoon-model",
    title: "Coming Soon,",
    message: "We Are Working On It.",
    image: "/images/logo.png",
    imageAlt: "Logo",
  },
  floatingBarData: {
    title: "Hi, we’re Bitsclan.",
    description:
      "Schedule a call to discover smarter ways to grow & innovate.",
    buttonText: "Book My Call",
  },
  locations: [
    {
      title: "Head Office",
      location: "New York",
      address: "2 Park Ave 20th floor, New York, NY 10016",
      addressLink: "https://maps.app.goo.gl/KLGhpKxNaL9qhyXq8",
      icon: "new-york.svg",
      altText: "Bitsclan Head Office New York City Headquarters",
    },
    {
      title: "Europe Office",
      location: "Sweden",
      address: "Barometergatan 16, 418 41 Göteborg, Sweden",
      addressLink: "https://maps.app.goo.gl/ujNgkiwdasgdErus5",
      icon: "Sweden.svg",
      altText: "Bitsclan Europe Office Sweden City Landmark",
    },
    {
      title: "Gulf Office",
      location: "KSA",
      address:
        "Building 26/27 - 120 A Support Industries, Jubail Industry City, Saudi Arabia",
      icon: "Qatar.svg",
      altText: "Bitsclan Gulf Office Saudi Arabia Jubail City",
    },
    {
      title: "Australia Office",
      location: "Queensland",
      address: "40 Saintly Road Logan Reserve Queensland Australia",
      icon: "Australia.svg",
      altText: "Bitsclan Australia Office Queensland City"
    },
  ],
  buttons: {
    contactUs: "Contact Us",
    scheduleACall: "Schedule a Call",
  },
  footerCtaContent: {
    heading: "Scale Faster with Dedicated Development Teams that Deliver",
    subHeading: "See how we can help.",
    buttonText: "Schedule a Call"
  }
};

export default footerContent;
